import React, { useContext, useEffect, useState } from "react";
import { BiMoon, BiSun } from "react-icons/bi";
import { ThemeContext } from "../../../contexts/themeConfig";
import { useLocation } from "react-router-dom";
import "./Header.scss";
import { Button, Tooltip, Typography } from "antd";
import { pageTitle } from "./Utilities/pageTitleInfo";
import { SidebarContext } from "../../../contexts/SidebarContext";
import {
  TbLayoutSidebarLeftCollapse,
  TbLayoutSidebarRightCollapse,
} from "react-icons/tb";
import { getPageTitle } from "../../../Utility/helper";
import { PageTitleContext } from "../../../contexts/TitleContext";
import NewChatWithSameAssistant from "../../Prompt/NewChatWithSameAssistant";
import DarkModeToggler from "../../common/DarkModeToggler/DarkModeToggler";
import { FaFolderOpen } from "react-icons/fa";
import SyncFilesFromNavBar from "../../Prompt/SyncFilesFromNavBar";
import { axiosSecureInstance } from "../../../api/axios";
import { CHECK_ASSISTANT_SYNC_ENABLE_STATUS } from "../../../constants/Api_constants";
import PlanAlert from "../../../Utility/PlanAlert";
import NavLinksContainer from "../../Prompt/NavLinksContainer";
import AssistantRating from "../../Assistant/AssistantRating";
// import logo from "../../../assests/images/Collab AI Logo White.png";

const Header = () => {
  const { theme, toggleTheme, themeIsChecked, setThemeIsChecked } = useContext(ThemeContext);
  const { setShowMenu, showMenu } = useContext(SidebarContext);
  const { pageTitle, setPageTitle } = useContext(PageTitleContext);
  const [isSyncEnable,setIsSyncEnable] = useState(false);
  const [isEmbedded, setIsEmbedded] = useState(false);
  const location = useLocation();
  const paramAssistantId = location.pathname.split("/")[2];

  useEffect(() => {
    const embeddedParam = new URLSearchParams(window.location.search).get("embedded") === "true";
    setIsEmbedded(embeddedParam);
  }, []);


  const checkAssistantSyncStatus = async (assistantId)=>{
    const isSyncEnabled = await axiosSecureInstance.get(CHECK_ASSISTANT_SYNC_ENABLE_STATUS(assistantId));
    if(isSyncEnabled.data.enableSync){
      setIsSyncEnable(isSyncEnabled.data.enableSync);
    }
  }

  useEffect(()=>{
    if(location.pathname.startsWith("/agents/")){
      setIsSyncEnable(false);
      checkAssistantSyncStatus(location.pathname.split("/")[2])
    }

  },[location.pathname]);

  if (isEmbedded) {
    return null;
  }

  // const isChatPath = /^\/chat\/.*$/.test(location.pathname);
  const isChatPath = location.pathname === "/chat";


  return (
    <>
    {isChatPath && <PlanAlert />}
    <nav
        className="navbar navbar-expand sticky-top nav-bar w-100 dark-color-header"
        aria-label="Second navbar example"
        // style={
        //   theme === "light"
        //     ? { backgroundColor: "#eef3ff" }
        //     : { backgroundColor: "#212121" }
        // }
      >
      <div className="container-fluid CustomFlex">
        <div className="d-flex align-items-center gap-2">
          {(location?.pathname === "/public-assistant" ||
            location.pathname === "/chat" ||
            location.pathname.startsWith("/chat/") ||
            location.pathname.startsWith("/agents/")) ? (
              <Tooltip title="Collapse button">
                  <button
                className="toggle-sidebar"
                onClick={() => {
                  setShowMenu((prevState) => !prevState);
                  }}
                >
                  {showMenu ? (
                    <TbLayoutSidebarLeftCollapse className="thread-bar-open-icon" />
                  ) : (
                    <TbLayoutSidebarRightCollapse className="thread-bar-close-icon" />
                  )}
               </button>
              </Tooltip>
          ): <></>}
          
          <Typography.Title level={5} className="rounded m-0">
          <div style={{ display: "flex", alignItems: "center", gap: "8px", ...(theme === "light"?{color:"rgb(27, 28, 29)"}:{color:"#ffffff"})}}>
                <div className="page-title">
                  <span style={{ fontSize: "18px" }}> {getPageTitle(location.pathname)?.icon ?? <></>}</span>
                  {getPageTitle(location.pathname)?.title ?? ""}
                </div>
                <div className="nav-links-container-wrapper">
                  <NavLinksContainer />
                </div>
              </div>
              {pageTitle[location.pathname] && (
                <NewChatWithSameAssistant assistantId={location.pathname.split("/")[2]} assistantName={pageTitle[location.pathname]} />
              )}
          </Typography.Title>
          <Typography.Title level={5} className="rounded m-0">
              {pageTitle[location.pathname] && isSyncEnable&&(
                <SyncFilesFromNavBar assistantId={location.pathname.split("/")[2]} assistantName={pageTitle[location.pathname]} />
              )}
          </Typography.Title>

        </div>
        <div className="d-flex align-items-center">
            <div className="me-5">
                {paramAssistantId?.slice(0, 5) === "asst_" && <AssistantRating assistantId={paramAssistantId} />}
            </div>
            <DarkModeToggler theme={theme} toggleTheme={toggleTheme} themeIsChecked={themeIsChecked} setThemeIsChecked={setThemeIsChecked}/>
          </div>
    
      </div>
    </nav>
    </>
  );
};

export default Header;
